import { Component, OnInit, Input } from "@angular/core";
import { OptionTextDirective } from "../option-text/option-text.directive";
import { ApplicationModel } from "../../../../core/models/application.model";

@Component({
	selector: "app-vector-option-text",
	templateUrl: "./vector-option-text.directive.html",
	styleUrls: ["./vector-option-text.directive.scss"],
})
export class VectorOptionTextDirective extends OptionTextDirective {
	public textDirection;
	public textAlign;

	ngOnInit() {
		this.textDirection = ApplicationModel.instance.flowDirection;
		this.textAlign = ApplicationModel.instance.textDirection;
	}

	public clicked(event, option: any) {
		//  event.stopPropagation();
		// console.log("option.selected ",option.selected);
		if (!option.selected) {
			option.backgroundColor = "#9DB7D0";
			option.selected = true;
			//console.log("option.selected if condition",option.selected);
		} else {
			option.selected = false;
			option.backgroundColor = "";
		}
		this.OptionSelected.emit({ item: option });
	}
}
